var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DemoBase',{attrs:{"size":"xs4"}},[_c('Checkbox',{attrs:{"title":"Demo","color":"primary"}}),_vm._v(" Custom checkbox "),_c('Checkbox',{attrs:{"custom":"","title":"Demo","color":"primary"}},[_c('SP',{attrs:{"class-object":['font-weight-bold']}},[_vm._v("Hello")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }